module.exports = __webpack_public_path__ + "img/membership_pc.da05c9f6.jpg";